import { useEffect, useRef, useState } from 'react';

export interface RowMenuItem {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  title?: string | undefined;
}

interface RowMenuProps {
  items: RowMenuItem[];
}

// Menú contextual "⋮" por fila — reutiliza el look de .ms-dropdown/.ms-opt
// (ya usado en CheckboxDropdown) para no introducir un patrón visual nuevo.
export function RowMenu({ items }: RowMenuProps) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  if (items.length === 0) return null;

  return (
    <div style={{ position: 'relative', display: 'inline-block' }} ref={wrapRef}>
      <button
        type="button"
        className="btn-ghost"
        style={{ padding: '4px 9px', fontSize: 17, lineHeight: 1, borderRadius: 6 }}
        aria-label="Más acciones"
        onClick={e => {
          e.stopPropagation();
          setOpen(o => !o);
        }}
      >
        ⋮
      </button>
      {open && (
        <div className="ms-dropdown" style={{ left: 'auto', right: 0, width: 200 }}>
          {items.map((item, i) => (
            <div
              key={i}
              className="ms-opt"
              title={item.title}
              style={item.disabled ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
              onClick={e => {
                e.stopPropagation();
                if (item.disabled) return;
                item.onClick();
                setOpen(false);
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
